<template>
  <div class="p-6 bg-white border-t border-gray-200">
    <ValidationObserver ref="observer">
      <template #default="{ handleSubmit }">
        <NoteForm
          :content.sync="data.content"
          :disabled="updating"
          @submit="handleSubmit(update)"
          @cancel="cancel"
        />
      </template>
    </ValidationObserver>
  </div>
</template>

<script>
import NoteFormVue from '@/components/Notes/NoteForm.vue';
import { HTTP_UNPROCESSABLE_ENTITY } from '@/api/http-response-codes';
import veeValidateErrorsMixin from '@/mixins/veeValidateErrorsMixin';

export default {
  mixins: [veeValidateErrorsMixin],

  components: {
    NoteForm: NoteFormVue,
  },

  props: {
    note: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      updating: false,
      data: {
        content: this.note.content,
      },
      errorMsg: '',
    };
  },

  methods: {
    setUpdating(value) {
      this.updating = value;
      this.$emit('updating', value);
    },
    async update() {
      if (this.updating) return;

      this.setUpdating(true);

      try {
        const result = await this.$store.dispatch({
          type: 'ui/notes/update',
          id: this.note.id,
          body: this.data,
        });

        this.$emit('updated', result);
      } catch (error) {
        if (!error.response) {
          return;
        }

        const { status, data: { errors = [], message = '' } = {} } = error.response;

        if (status !== HTTP_UNPROCESSABLE_ENTITY) {
          return;
        }

        this.applyServerErrors(errors);
        this.errorMsg = message;
      } finally {
        this.setUpdating(false);
      }
    },
    cancel() {
      this.$emit('cancel');
    },
    applyServerErrors(errors) {
      this.observer = this.$refs.observer;
      this.addServerErrors(errors);
    },
  },
};
</script>
